// core
import React from "react";
import ErrorBoundaryContainer from "../../containers/ErrorBoundaryContainer";
import MaterialThemeProvider from "../../providers/MaterialThemeProvider";
import PageBlurProvider from "../../../common/components/Modals/PageBlurProvider";

// styles
import "./AppWrapper.scss";

const AppWrapper: React.FC<{}> = (props) => {
    return (
        <PageBlurProvider>
            <MaterialThemeProvider>
                <ErrorBoundaryContainer>{props.children}</ErrorBoundaryContainer>
            </MaterialThemeProvider>
        </PageBlurProvider>
    );
};

export default AppWrapper;
